import { Grid, Tooltip } from '@mui/material';
import React, {useState} from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';

import './App.css';
import worldCountries from './SupportedData/world-countries.json';
import paymentsByCountry from './SupportedData/paymentsByCountry.json';
import fiatsByCountry from './SupportedData/fiatsByCountry.json';
import onrampCountByCountry from './SupportedData/onrampCountByCountry.json';
import { TooltipData } from './components/TooltipData/TooltipData';

function App() {
  const GeoStyle = {
    hover: {
    fill: '#00b46e',
    outline: 'none'
    },
    pressed: {
    fill: '#00b46e',
    outline: 'none'
    },
    default: {
        outline: 'none'
    }
  };

  const [openCountry, setOpenCountry] = React.useState(false);
  const [clickedCountry, setClickedCountry] = useState('');
  const shouldOpen = (isClicked, geo) => {
    if(isClicked) return true;
    if(openCountry === geo.properties.name)
      return true;
    return false;
  };
  const handleClose = () => {
    setOpenCountry(undefined);
  };
  const handleOpen = (geo) => {
    if(geo?.properties?.name){
      setOpenCountry(geo.properties.name);
    }
  };

  const handleClick = (geo) => {
    if(geo?.properties?.name){
      setClickedCountry(clickedCountry !== geo.properties.name ? geo.properties.name : '');
    }
  };

  return (
    <Grid>
      <ComposableMap
        height={400}
        projection='geoMercator'
        projectionConfig={{
          center: [0, 20],
          scale: 127,
        }}
      >
        <Geographies 
          parseGeographies={(geos) => {
            return geos.map((g) => {
              const payments = paymentsByCountry.find((o) => o.id === g.properties['Alpha-2']);
              const fiat = fiatsByCountry.find((o) => o.code === g.properties['Alpha-2']);
              const onrampCount = onrampCountByCountry.find((o) => o.country === g.properties['Alpha-2']);
              g.paymentsText = '';
              g.onrampCount = onrampCount?.count ?? 0;
              if(payments){
                g.paymentsText = payments.payments.map((p) => p.name)?.join(' . ');
                g.fiat = fiat.fiat;
                g.payments = payments;
              }
              return g;
            })
          }}
          geography={worldCountries}>
          {({ geographies }) =>
            geographies.map((geo) => {
              const isClicked = clickedCountry === geo.properties.name;
              return <Tooltip 
                key={geo.rsmKey}
                componentsProps={{
                  tooltip: {
                    sx: {
                      bgcolor: 'common.white',
                      border: 1,
                      borderRadius: '24px',
                      padding: '24px',
                      pb: '16px',
                      color: 'common.black',                      
                    },
                  },
                }}
                title=
                  {<TooltipData geo={geo}/>}
                open={isClicked ? true : shouldOpen(isClicked, geo)}
                onClose={() => handleClose(geo)}
                onOpen={() => handleOpen(geo)}
                followCursor={!isClicked ? true : false}>
                  <Geography
                    geography={geo}
                    fill={isClicked ? '#00b46e' : geo?.payments?.count > 0 ? '#6affc5' : '#E6E6E6' }
                    stroke='#FFFFFF'
                    onClick={() => handleClick(geo)}
                    style={GeoStyle}
                  />
                </Tooltip>
            })
          }
        </Geographies>
      </ComposableMap>
    </Grid>
);
}

export default App;
